import { c as _c } from "react/compiler-runtime";
import { Box } from "@mui-wrapper";
import ReactDOM from "react-dom";
/**
 * Component that creates an overlay to cover the entire screen with a transparent layer.
 * Useful for modalities and modals that require user focus on a single interaction.
 *
 * @param children The content to render within the overlay.
 * @returns A React portal rendering the provided content over the "root" element in the DOM.
 */
export function Overlay(t0) {
  const $ = _c(3);
  const {
    children
  } = t0;
  let t1;
  if ($[0] !== children) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "transparent",
        zIndex: 9999
      };
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    t1 = ReactDOM.createPortal(<Box role="overlay" sx={t2}>{children}</Box>, document.body);
    $[0] = children;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}